/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { post } from "../../../utils/sysAxios";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import SysTable from "../../commonComponents/SysTable";
import { toastError } from "../../../utils/sysToast";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

class Audit extends Component {
  state = {
    dates: "",
    userId: "",
    allUsers: [],
    contentHeader: "Audit",

    dataUrl: "/api/data/GetAudits",

    tableData: [],

    // Compare dialog
    inCompareMode: false,
    compareRecord: null,
    compareRows: [],
    onlyChanged: true,
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.username"),
        field: "USERNAME",
      },
      {
        id: 2,
        label: t("col.action"),
        field: "ACTION_TYPE",
      },
      {
        id: 3,
        label: t("col.entity"),
        field: "REF_TYPE",
      },
      {
        id: 4,
        label: t("col.recordId"),
        field: "REF_ID",
      },
      {
        id: 5,
        label: t("col.description"),
        field: "REF_DESC",
      },
      {
        id: 6,
        label: t("col.actionDate"),
        field: "AUDIT_DATE",
      },
      {
        id: 7,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "80px",
        maxResizeWidth: "80px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            <div className="inner" title={t("audit.viewChanges")}>
              <button
                className="dropdown-item btn-popup-menu"
                disabled={this.props.isLoading}
                onClick={() => this.openCompare(data)}
              >
                <i className="fa fa-exchange" />
              </button>
            </div>
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getAllUsers();
  }

  getAllUsers() {
    post(
      "/api/data/getallusersdropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allUsers: apiResponse.data.respData.data,
      });
    });
  }

  getData() {
    if (!this.state.dates[0] || !this.state.dates[1]) {
      toastError("Please select DateFrom and DateTo");
    } else {
      post(
        this.state.dataUrl,
        {
          dateFrom: this.state.dates[0],
          dateTo: this.state.dates[1],
          userId: this.state.userId
        },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      });
    }
  }

  // Audit payloads are stored as JSON text. A record that predates a schema change,
  // or one written by a path that stored something else, must not break the screen.
  parseObject(raw) {
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed)
        ? parsed
        : null;
    } catch (e) {
      return null;
    }
  }

  formatValue(v) {
    if (v === null || v === undefined) return "";
    if (typeof v === "boolean") return v ? "true" : "false";
    if (typeof v === "object") return JSON.stringify(v);
    return String(v);
  }

  buildCompareRows(oldObj, newObj) {
    // Old keys first so the record reads in its stored order, then anything the
    // new object adds on top.
    const keys = [];
    Object.keys(oldObj || {}).forEach((k) => keys.push(k));
    Object.keys(newObj || {}).forEach((k) => {
      if (!keys.includes(k)) keys.push(k);
    });

    return keys.map((key) => {
      const hasOld = oldObj !== null && Object.prototype.hasOwnProperty.call(oldObj, key);
      const hasNew = newObj !== null && Object.prototype.hasOwnProperty.call(newObj, key);
      const oldValue = hasOld ? this.formatValue(oldObj[key]) : "";
      const newValue = hasNew ? this.formatValue(newObj[key]) : "";

      // With nothing to compare against (INSERT / DELETE) every field is just
      // reported as-is rather than being flagged as a change.
      const changed = oldObj !== null && newObj !== null && oldValue !== newValue;

      return { key, oldValue, newValue, changed };
    });
  }

  openCompare(row) {
    post(
      "/api/data/GetAuditDetails",
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse && apiResponse.data.respCode === 0) {
        const rec = apiResponse.data.respData.data;
        const oldObj = this.parseObject(rec.OLD_OBJECT);
        const newObj = this.parseObject(rec.NEW_OBJECT);

        this.setState({
          inCompareMode: true,
          compareRecord: rec,
          compareRows: this.buildCompareRows(oldObj, newObj),
          onlyChanged: oldObj !== null && newObj !== null,
        });
      }
    });
  }

  closeCompare() {
    this.setState({
      inCompareMode: false,
      compareRecord: null,
      compareRows: [],
    });
  }

  hasBothSides() {
    const rec = this.state.compareRecord;
    return !!(rec && rec.OLD_OBJECT && rec.NEW_OBJECT);
  }

  visibleCompareRows() {
    if (this.state.onlyChanged && this.hasBothSides()) {
      return this.state.compareRows.filter((r) => r.changed);
    }
    return this.state.compareRows;
  }

  changedCount() {
    return this.state.compareRows.filter((r) => r.changed).length;
  }

  render() {
    const { t } = this.props;
    const rec = this.state.compareRecord;
    const bothSides = this.hasBothSides();
    const visibleRows = this.visibleCompareRows();

    return (
      <div className="bms-content-component fade-in">
        <div className="row align-items-center">
          <div className="col">
            <h4>{t("pages.audit")}</h4>
          </div>
        </div>
        <div className="page-filter-bar">
          <span className="filter-label">{t("filter.date")}:</span>
          <Calendar
            selectionMode="range"
            showIcon
            value={this.state.dates}
            onChange={(e) => this.setState({ dates: e.value })}
          />
          <span className="filter-label">{t("filter.username")}:</span>
          <Dropdown
            value={this.state.userId}
            showClear
            options={this.state.allUsers}
            filter
            onChange={(e) => this.setState({ userId: e.target.value })}
          />
          <Button
            label={t("btn.search")}
            icon="fa fa-search"
            className="p-button-rounded p-button-secondary"
            disabled={this.props.isLoading}
            onClick={() => this.getData()}
          />
        </div>
        <hr />

        {/* Old vs new comparison */}
        <Dialog
          visible={this.state.inCompareMode}
          style={{ width: "75vw" }}
          onHide={() => this.closeCompare()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("audit.compareTitle")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.close")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeCompare()}
              />
            </div>
          }
        >
          {rec && (
            <div style={{ marginBottom: "12px", display: "flex", gap: "16px", flexWrap: "wrap", fontSize: "13px", color: "black" }}>
              <span><b>{t("col.action")}:</b> {rec.ACTION_TYPE}</span>
              <span><b>{t("col.entity")}:</b> {rec.REF_TYPE}</span>
              <span><b>{t("col.recordId")}:</b> {rec.REF_ID}</span>
              <span><b>{t("col.username")}:</b> {rec.USERNAME}</span>
              <span><b>{t("col.actionDate")}:</b> {rec.AUDIT_DATE}</span>
            </div>
          )}

          {rec && rec.REF_DESC && (
            <div style={{ marginBottom: "12px", fontSize: "13px", color: "#555" }}>
              {rec.REF_DESC}
            </div>
          )}

          {!bothSides && (
            <div style={{ marginBottom: "10px", padding: "8px 12px", background: "#fff3cd", color: "#856404", borderRadius: "4px", fontSize: "13px" }}>
              {rec && rec.ACTION_TYPE === "INSERT"
                ? t("audit.insertOnlyHint")
                : t("audit.noOldSnapshot")}
            </div>
          )}

          {bothSides && (
            <div style={{ marginBottom: "10px", display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#fff3cd", color: "#856404", padding: "4px 10px", borderRadius: "20px", fontWeight: "600", fontSize: "13px" }}>
                <b>{this.changedCount()}</b>
                {t("audit.changedFields")}
              </span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                <Checkbox
                  inputId="onlyChanged"
                  checked={this.state.onlyChanged}
                  onChange={(e) => this.setState({ onlyChanged: e.checked })}
                />
                <label htmlFor="onlyChanged" style={{ margin: 0, fontSize: "13px", color: "black" }}>
                  {t("audit.onlyChanged")}
                </label>
              </span>
            </div>
          )}

          <div style={{ maxHeight: "58vh", overflowY: "auto" }}>
            <table className="table table-sm table-bordered" style={{ fontSize: "13px" }}>
              <thead className="thead-light" style={{ position: "sticky", top: 0 }}>
                <tr>
                  <th style={{ width: "26%" }}>{t("audit.field")}</th>
                  <th>{t("audit.oldValue")}</th>
                  <th>{t("audit.newValue")}</th>
                </tr>
              </thead>
              <tbody>
                {visibleRows.length === 0 && (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center", color: "#666" }}>
                      {bothSides ? t("audit.noChanges") : t("table.noRecords")}
                    </td>
                  </tr>
                )}
                {visibleRows.map((r, i) => (
                  <tr key={i} className={r.changed ? "table-warning" : ""}>
                    <td style={{ fontWeight: r.changed ? "600" : "400" }}>{r.key}</td>
                    <td style={{ color: r.changed ? "#721c24" : "inherit", wordBreak: "break-word" }}>
                      {r.oldValue}
                    </td>
                    <td style={{ color: r.changed ? "#155724" : "inherit", fontWeight: r.changed ? "600" : "400", wordBreak: "break-word" }}>
                      {r.newValue}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Dialog>

        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Audit);
